<template>
    <transition name="fade">
        <div class="overlay" ref="overlay">
            <div class="background" @click="close"></div>
            <img class="close-button" src="@/assets/close.svg" @click="close">
            <div class="panel-container wh100" layout="row center-center">
                <div class="panel">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "lightbox",
        mounted() {
            window.document.body.appendChild(this.$refs.overlay);
        },
        methods: {
            close() {
                this.$emit('onClose', this);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overlay {
        position: absolute;
        top:0;
        left:0;
        padding: 0;
        margin: 0;
        width:100vw;
        height:100vh;
        z-index: 1000;
    }
    .background {
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        background-color: rgba(25, 25, 25, 0.9);
        max-width: 100vw;
        max-height: 100vh;
    }

    .panel-container {
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        pointer-events: none;
        overflow: hidden;
    }

    .panel {
        background-color: #161616;
        padding: 1rem;
        /*border-radius: 0.8rem;*/
        pointer-events: auto;
        margin: 0;
        /*padding: 0;*/
        z-index: 101;
        overflow: hidden;
        /*filter: drop-shadow(0 0 4px rgba(0,0,0, 0.5));*/
    }

    .close-button {
        width: 2rem;
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 101;

    }

    .fade-enter-active {
        transition: opacity 0.3s ease-in-out;
    }

    .fade-enter-to {
        opacity: 1;
    }

    .fade-enter {
        opacity: 0;
    }
</style>
